<template>
  <div id="app">
    <RouterView></RouterView>
    <Notifications />
    <CookieAgreement />
  </div>
</template>

<script>
import Notifications from '@/components/Global/Notifications.vue';
import CookieAgreement from '@/components/Global/CookieAgreement.vue';
import toast from '@/notify';

export default {
  name: 'App',
  components: {
    Notifications,
    CookieAgreement,
  },
  mounted() {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') !== -1) {
      if (ua.indexOf('chrome') === -1) {
        toast.danger({
          duration: 10000,
          title: this.$t('errors.maybe-error'),
          text: this.$t('errors.use-are-using-outdated-browser'),
        });
      }
    }
  },
};
</script>

<style lang="scss">
#app {
  @apply h-full;
  text-align: center;
  color: #2c3e50;
}

.main {
  background-image: url('./assets/images/main-bg.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: scroll;
}
</style>
